<template>
	<svg
		width="15"
		height="15"
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<line
			x1="1"
			y1="-1"
			x2="16.5156"
			y2="-1"
			transform="matrix(0.711258 0.702931 -0.711258 0.702931 0.954712 1.93359)"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
		/>
		<line
			x1="1"
			y1="-1"
			x2="16.5156"
			y2="-1"
			transform="matrix(0.711258 -0.702931 0.711258 0.702931 2.08752 14.2461)"
			stroke="black"
			stroke-width="2"
			stroke-linecap="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'CloseNoGaWarning',
};
</script>
